import { render } from "./Ocean.vue?vue&type=template&id=4e8782a1&scoped=true"
import script from "./Ocean.vue?vue&type=script&lang=js"
export * from "./Ocean.vue?vue&type=script&lang=js"

import "./Ocean.vue?vue&type=style&index=0&id=4e8782a1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8782a1"]])

export default __exports__